// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入时间格式转换方法
import { formatDate } from "@/utils/validate.js";
export default {
  data() {
    return {
      // 表单对象
      form: {
        id: null, // 主键
        regBasicinfoId: null, // 注册人员主键
        corpBasicinfoId: null, // 所属企业主键
        corpBasicinfoCode: null, // 所属企业编号
        corpBasicinfoName: null, // 所属企业名称
        regType: null, // 证书类型
        regLevel: null, // 证书等级
        certNum: null, // 证书编号
        awardDate: null, // 发证日期
        awardDepart: null, // 发证单位
        effectDate: null, // 证书有效期
        regTradeTypeNum: null, // 证书专业
        qstate: null, // 执业资格状态
        tradeTypeAwardDate: null, // 证书开始日期
        tradeTypeEffectDate: null // 证书截止日期
      },
      // 列表loading状态
      loading: false,
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null, // 页面类型
      saveBtnShow: false, // 保存按钮显示
      regLevels: [], // 证书等级下拉框的值
      regTradeTypeNums: [], // 证书等级下拉框的值
      regLevelShow: false, // 证书等级下拉框是否显示
      regTradeTypeShow: false // 证书等级下拉框是否显示
    };
  },
  // 接收父组件传递的数据
  props: {},
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    /**
     * 打开弹框时调用
     * @returns {Promise<void>}
     */
    async fun_GetOpen() {
      // 如果是详情
      if (this.controllerFlg == "details") {
        // 遍历表单
        this.formConfigList.map(e => {
          // 遍历
          e.formConfigList.map(form => {
            // 不可编辑
            form.disabled = true;
          });
        });
        // 获取详情信息
        this.fun_Details();
        // 注册证书等级置灰
        this.regLevelShow = true;
        // 注册证书专业置灰
        this.regTradeTypeShow = true;
      }
      // 如果是添加
      else if (this.controllerFlg == "insert") {
        // 保存按钮显示
        this.saveBtnShow = true;
      }
      // 如果是修改
      else if (this.controllerFlg == "update") {
        // 获取详情信息
        this.fun_Details();
        // 保存按钮显示
        this.saveBtnShow = true;
      }
    },
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/regPersonReginfo/detail", {
        id: this.form.id,
        regBasicinfoId: this.form.regBasicinfoId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 调用证书等级下拉框
          this.fun_GetRegLevelSelect();
          // 调用证书专业下拉框
          this.fun_GetRegTradeTypeNumSelect();
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author panmin
     */
    fun_GetSelectVal(e, i) {
      // 证书类型
      if (i === "regType") {
        // 赋值
        this.form.regType = e;
        // 设置证书等级为空
        this.form.regLevel = "";
        // 设置证书专业为空
        this.form.regTradeTypeNum = "";
        // 调用证书等级下拉框
        this.fun_GetRegLevelSelect();
        // 调用证书专业下拉框
        this.fun_GetRegTradeTypeNumSelect();
      }
      // 证书等级
      else if (i === "regLevel") {
        // 赋值
        this.form.regLevel = e;
      }
      // 证书专业
      else if (i === "regTradeTypeNum") {
        // 赋值
        this.form.regTradeTypeNum = e;
      }
      // 执业资格状态
      else if (i === "qstate") {
        // 赋值
        this.form.qstate = e;
      }
    },
    /**
     * 证书等级下拉框设置
     */
    fun_GetRegLevelSelect() {
      // 请求，获取结果集
      fun_PostAction("/regTradeLevel/RegTradeLevelCombobox", {
        tradeType: this.form.regType
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 证书等级下拉框
          this.regLevels = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 证书专业下拉框设置
     */
    fun_GetRegTradeTypeNumSelect() {
      // 请求，获取结果集
      fun_PostAction("/regTradeType/RegTradeTypeCombobox", {
        tradeType: this.form.regType
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 证书专业下拉框
          this.regTradeTypeNums = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 发证日期不为空时
          if (this.form.awardDate != "" && this.form.awardDate != null) {
            // 截取年月日
            this.form.awardDate = formatDate(
              new Date(this.form.awardDate),
              "yyyy-MM-dd"
            );
          }
          // 证书有效期不为空时
          if (this.form.effectDate != "" && this.form.effectDate != null) {
            // 截取年月日
            this.form.effectDate = formatDate(
              new Date(this.form.effectDate),
              "yyyy-MM-dd"
            );
          }
          // 证书开始日期不为空时
          if (
            this.form.tradeTypeAwardDate != "" &&
            this.form.tradeTypeAwardDate != null
          ) {
            // 截取年月日
            this.form.tradeTypeAwardDate = formatDate(
              new Date(this.form.tradeTypeAwardDate),
              "yyyy-MM-dd"
            );
          }
          // 证书截止日期不为空时
          if (
            this.form.tradeTypeEffectDate != "" &&
            this.form.tradeTypeEffectDate != null
          ) {
            // 截取年月日
            this.form.tradeTypeEffectDate = formatDate(
              new Date(this.form.tradeTypeEffectDate),
              "yyyy-MM-dd"
            );
          }
          // 请求
          fun_PostAction("/regPersonReginfo/saveOrUpdate", {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
              // 返回一览
              this.fun_Back();
            }
          });
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 关闭详情页面弹框
      this.$parent.detailDialogVisible = false;
      // 重新调用详情页面方法
      this.$parent.fun_GetOpen();
    }
  }
};
